<template>
  <div class="ticket">
    <div class="right-container">
      <div class="right-container-event-info">
        <p class="title-small">{{ eventInfo.eventTitle }}</p>
        <p class="ticket-name-small">{{ ticketName }}</p>
        <p class="time-small">{{ formatDate(eventInfo.eventFrom) }}</p>
      </div>
      <div class="right-container-qrcode">
        <p class="ticket-number">{{ ticketInfo.accreditation.id }}</p>
        <canvas ref="qrcode" class="qrcode" :style="{ margin: 0, padding: 0 }" />
      </div>
    </div>
    <div class="left-container">
      <div class="ticket-data-container">
        <canvas ref="qrcode2" class="qrcode" :style="{ margin: 0, padding: 0 }" />
        <div class="ticket-data-content">
          <div class="ticket-data-content-upper">
            <p class="ticket-info-data">Broj ulaznice:</p>
            <p class="ticket-number">{{ ticketInfo.accreditation.id }}</p>
          </div>
          <div class="ticket-data-content-lower">
            <p class="ticket-info-data">
              Cijena: <strong>{{ displayPrice }} EUR</strong>
            </p>
            <p class="ticket-info-data">Osnovica: {{ round(displayPrice * 0.95, 2) }} EUR</p>
            <p class="ticket-info-data">PDV (5%): {{ round(displayPrice * 0.05, 2) }} EUR*</p>
          </div>
        </div>
      </div>
      <div class="event-data-container">
        <div class="event-data-content-upper">
          <p class="title-big">{{ eventInfo.eventTitle }}</p>
          <p class="ticket-name-big">{{ ticketName }}</p>
        </div>
        <div class="event-data-content-lower">
          <p class="time-big">{{ formatDate(eventInfo.eventFrom) }}</p>
          <p class="additional-text">
            <strong>{{ eventInfo.venue }},</strong> {{ formattedEventLocation }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import moment from 'moment/moment'
import { round } from 'lodash'

export default {
  name: 'cibona-ticket-seller-pdf',
  props: {
    eventInfo: Object,
    organization: Object,
    ticketInfo: Object,
    ticketName: {
      type: String,
      default: '',
    },
    orderPaymentType: String,
    index: Number,
    ticketCount: Number,
  },
  data() {
    return {
      totalPriceRounded: null,
    }
  },
  computed: {
    displayPrice() {
      return this.orderPaymentType === 'FREE' ? 0 : this.ticketInfo.orderItem.price
    },
    formattedEventLocation() {
      return [
        this.eventInfo.address1,
        this.eventInfo.postalCode,
        this.eventInfo.city,
        this.eventInfo.country,
      ]
        .filter(Boolean)
        .join(', ')
    },
  },
  async mounted() {
    this.generateQrCode(this.fiscalisationInfo)
    this.loading = false
  },
  methods: {
    round,
    async generateQrCode() {
      const canvas1 = this.$refs.qrcode
      const canvas2 = this.$refs.qrcode2

      QRCode.toDataURL(canvas1, this.ticketInfo.accreditation.qrcode.toString(), {
        width: 80,
        margin: 0,
      })
      QRCode.toDataURL(canvas2, this.ticketInfo.accreditation.qrcode.toString(), {
        width: 80,
        margin: 0,
      })
    },
    formatDate(date) {
      return moment(date).tz('Europe/Zagreb').format('DD.MM.YYYY. [u] HH:mm')
    },
  },
}
</script>

<style scoped>
.application--wrap {
  min-height: fit-content !important;
}

.ticket {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 80mm;
  height: 210mm;
  overflow: hidden;
  box-sizing: border-box;
}

.right-container {
  display: flex;
  position: absolute;
  top: 12mm;
  left: 0;
  transform-origin: top left;
  transform: rotate(-90deg) translateX(-41.97mm);
  justify-content: space-between;
  flex-direction: column;
  width: 53.97mm;
  height: 80mm;
  padding: 5.34mm 0 5.34mm 2mm;
}

p,
h1 {
  margin-bottom: 0;
}

.left-container {
  position: absolute;
  top: 80mm;
  left: 0;
  transform-origin: top left;
  transform: rotate(-90deg) translateX(-130mm);
  width: 156.03mm;
  height: 80mm;
  padding: 37.88mm 3.45mm 5.34mm 8.74mm;
  display: flex;
  gap: 7.81mm;
  align-items: flex-end;
}

.content {
  flex-direction: column;
  display: flex;
  overflow: hidden;
  height: 156px !important;
  width: 350px !important;
}

.content-group {
  display: flex;
  flex-direction: column;
}

.content-group p {
  color: #333;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 108%;
}

.event-name {
  color: #333;
  font-size: 24px;
  font-weight: 700;
  line-height: 108%;
  width: 400px;
}

.title-small,
.time-small {
  color: black;
  font-size: 10.5px;
  font-family: Open Sans;
  font-weight: 800;
  word-wrap: break-word;
}

.title-small {
  margin-bottom: 6.3px;
}

.ticket-name-small {
  color: black;
  font-size: 12.6px;
  font-family: Open Sans;
  font-weight: 800;
  text-transform: uppercase;
  word-wrap: break-word;
  margin-bottom: 6.3px;
}

.right-container-qrcode {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 2.5mm;
}

.ticket-number {
  color: black;
  font-size: 9.16px;
  font-family: Open Sans;
  font-weight: 700;
  letter-spacing: 6.4px;
  margin-bottom: 0;
}

.ticket-data-container {
  display: flex;
  gap: 2.71mm;
}

.ticket-info-data {
  color: black;
  font-size: 8px;
  font-family: Open Sans;
  font-weight: 400;
  white-space: nowrap;
}

.event-data-container {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  justify-content: space-between;
}

.title-big {
  color: black;
  font-size: 18px;
  font-family: Open Sans;
  font-weight: 800;
  word-wrap: break-word;
  margin-bottom: 6.3px;
}

.ticket-name-big,
.time-big {
  color: black;
  font-size: 12.6px;
  font-family: Open Sans;
  font-weight: 800;
  text-transform: uppercase;
  word-wrap: break-word;
}

.time-big {
  margin-bottom: 5px;
}

.additional-text {
  color: black;
  font-size: 8.4px;
  font-family: Open Sans;
  font-weight: 400;
  word-wrap: break-word;
}

.ticket-data-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-self: stretch;
}

@media print {
  .application--wrap {
    min-height: auto !important;
  }

  .ticket {
    break-after: page;
    page-break-after: always;
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .ticket:last-of-type {
    break-after: auto;
    page-break-after: auto;
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    padding: 0;
  }
}
</style>
